import _tslib from "tslib";
import { dew as _CharCodesDew } from "../syntax/CharCodes";
import { dew as _utilsDew } from "../../utils";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var tslib_1 = _tslib;

  var CharCodes_1 = tslib_1.__importDefault(_CharCodesDew());

  var utils_1 = _utilsDew();

  var PDFHeader =
  /** @class */
  function () {
    function PDFHeader(major, minor) {
      this.major = String(major);
      this.minor = String(minor);
    }

    PDFHeader.prototype.toString = function () {
      var bc = utils_1.charFromCode(129);
      return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
    };

    PDFHeader.prototype.sizeInBytes = function () {
      return 12 + this.major.length + this.minor.length;
    };

    PDFHeader.prototype.copyBytesInto = function (buffer, offset) {
      var initialOffset = offset;
      buffer[offset++] = CharCodes_1.default.Percent;
      buffer[offset++] = CharCodes_1.default.P;
      buffer[offset++] = CharCodes_1.default.D;
      buffer[offset++] = CharCodes_1.default.F;
      buffer[offset++] = CharCodes_1.default.Dash;
      offset += utils_1.copyStringIntoBuffer(this.major, buffer, offset);
      buffer[offset++] = CharCodes_1.default.Period;
      offset += utils_1.copyStringIntoBuffer(this.minor, buffer, offset);
      buffer[offset++] = CharCodes_1.default.Newline;
      buffer[offset++] = CharCodes_1.default.Percent;
      buffer[offset++] = 129;
      buffer[offset++] = 129;
      buffer[offset++] = 129;
      buffer[offset++] = 129;
      return offset - initialOffset;
    };

    PDFHeader.forVersion = function (major, minor) {
      return new PDFHeader(major, minor);
    };

    return PDFHeader;
  }();

  exports.default = PDFHeader; //# sourceMappingURL=PDFHeader.js.map

  return exports;
}